import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Terms() {
  const email = siteConfig.contact?.email;

  useEffect(() => {
    document.title = `Terms — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="policy-page policy-page--terms" id="main-content">
      <header className="policy-hero">
        <p className="policy-eyebrow">Shop terms</p>
        <h1>The friendly ground rules.</h1>
        <p>
          These terms explain the agreement between you and {siteConfig.brandName}
          when you browse our site or place an order.
        </p>
        <span>Last updated August 14, 2026</span>
      </header>

      <div className="policy-layout">
        <aside className="policy-nav" aria-label="Terms and conditions sections">
          <p>On this page</p>
          <a href="#terms-orders">Orders and payment</a>
          <a href="#terms-products">Products and pricing</a>
          <a href="#terms-shipping">Shipping and returns</a>
          <a href="#terms-use">Acceptable use</a>
          <a href="#terms-liability">Liability</a>
          <a href="#terms-contact">Contact us</a>
        </aside>

        <article className="policy-content">
          <section className="policy-lead">
            <h2>Welcome</h2>
            <p>
              By using this website, you agree to these terms and our
              <Link to="/privacy"> privacy policy</Link>. If you do not agree,
              please do not use the site. You must be legally able to enter a
              contract in your place of residence to make a purchase.
            </p>
          </section>

          <section id="terms-orders">
            <h2>Orders and payment</h2>
            <p>
              Your order is an offer to purchase. It is accepted when we send
              an order confirmation. We may decline or cancel an order because
              of inventory errors, suspected fraud, payment issues or an
              incorrect price. If payment has already been captured, we will
              issue a refund to the original method.
            </p>
            <p>
              You agree to provide current, accurate billing and delivery
              information. Taxes and delivery charges are shown before you
              submit payment.
            </p>
          </section>

          <section id="terms-products">
            <h2>Products, colors and pricing</h2>
            <p>
              We work hard to show products accurately, but paper color and
              finish can vary slightly by screen and production run. Prices,
              descriptions and availability may change without notice. Obvious
              typographical or pricing errors do not bind us.
            </p>
          </section>

          <section>
            <h2>Promotions and gift cards</h2>
            <p>
              Discount codes are subject to their stated dates and conditions,
              cannot be combined unless expressly noted and have no cash value.
              Gift cards are handled according to the terms shown when purchased.
            </p>
          </section>

          <section id="terms-shipping">
            <h2>Shipping, returns and risk</h2>
            <p>
              Delivery estimates are not guarantees. Responsibility for an
              order transfers as permitted by applicable law when it is
              delivered to the address supplied. Read our <Link to="/shipping">shipping guide</Link>
              {" "}and <Link to="/returns">returns policy</Link> before ordering.
            </p>
          </section>

          <section>
            <h2>Creative work and trademarks</h2>
            <p>
              Site copy, illustrations, card designs, photography, graphics
              and branding belong to {siteConfig.brandName} or our licensors.
              Personal shopping use is welcome; reproducing, selling or using
              our work commercially without written permission is not.
            </p>
          </section>

          <section id="terms-use">
            <h2>Acceptable use</h2>
            <p>You may not use the site to:</p>
            <ul>
              <li>Break a law, infringe another person’s rights or submit harmful content.</li>
              <li>Interfere with site security, introduce malicious code or scrape the shop at scale.</li>
              <li>Impersonate another person or submit false account or payment information.</li>
              <li>Resell site access or copy product designs without permission.</li>
            </ul>
          </section>

          <section id="terms-liability">
            <h2>Disclaimers and liability</h2>
            <p>
              The site is provided on an “as available” basis to the extent
              permitted by law. We do not promise uninterrupted or error-free
              access. To the fullest extent allowed, we are not responsible for
              indirect or consequential losses. Nothing here limits rights or
              remedies that cannot legally be excluded.
            </p>
          </section>

          <section>
            <h2>Changes and governing law</h2>
            <p>
              We may update these terms by posting a revised version and date.
              Applicable consumer law and the law of the jurisdiction where
              our business is established govern these terms, without taking
              away mandatory protections available where you live.
            </p>
          </section>

          <section className="policy-contact" id="terms-contact">
            <p className="policy-eyebrow">Questions?</p>
            <h2>We are happy to clarify.</h2>
            <p>
              Reach us through the <Link to="/contact">contact page</Link>
              {email && <> or at <a href={`mailto:${email}`}>{email}</a></>}.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
